/// <amd-module name="Reporting/BoardsCommon/UnmaterializedBoardMessage" />
import * as React from "react";
import { getNavigateToBoardHandler } from "Reporting/BoardsCommon/BoardsRoutingHelper";
import * as Resources from "Reporting/BoardsCommon/Resources";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { ZeroData, ZeroDataActionType } from "VSSUI/ZeroData";

/** Common abstraction for Errors on Report Pages. */
export class UnmaterializedBoardMessage extends VssComponent {
    public navigateTo: () => void;

    constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
        this.navigateTo = getNavigateToBoardHandler(context.pageContext);
    }

    public render(): JSX.Element {
        return (
            <ZeroData
                primaryText={Resources.UnmaterializedBoardHeader}
                secondaryText={<span>{Resources.UnmaterializedBoardDetail}</span>}
                imageAltText={Resources.DataNotFoundImageDescription}
                imagePath={getAssetLocation(
                    this.context.pageContext,
                    "ms.vss-reporting-web/boards-reporting-common-content/images/data-not-found.svg"
                )}
                actionText={Resources.GoToBoard}
                actionType={ZeroDataActionType.ctaButton}
                onActionClick={this.navigateTo}
            />
        );
    }
}
